<script setup>
    import {useFormModalControlsStore} from "../stores/FormModalControls";

    const props = defineProps({
        title: String
    })

    const formModalControls = useFormModalControlsStore(),
        { formModalOpen, formModalSetTitle } = formModalControls

    function populateFormModal() {
        formModalSetTitle(`Application form: ${props.title}`)
        formModalOpen()
    }
</script>
<template>
    <div @click="populateFormModal()">
        <button class="gradient-button gradient-button--orange">
            <span>Apply</span>
        </button>
    </div>
</template>
